export default {
  title: '大师航拍',
  // 底栏右下角菜单里的五项。刻意用短标签，和 buttonText 里那几条长文案
  // （扫码航拍 / 联系客服）分开 —— 菜单一行只有 192px 宽，放不下长的。
  // 首页卡片样片上那颗「看样片」药丸按钮
  videoPill: {
    watchSample: '看样片',
  },
  appMenu: {
    title: '菜单',
    scan: '扫码',
    language: '语言',
    notice: '消息',
    service: '客服',
    setting: '设置',
  },
  tabBar: {
    aerial: '航拍',
    masterMap: '大师地图',
    // 「回首页」的按钮用这个。别复用 masterMap —— 首页改版之后它不再是一张地图，
    // 而 masterMap 那个 key 还在给底栏那颗地图按钮和地图弹窗的标题用。
    home: '首页',
    memory: '回忆',
    profile: '我的',
    order: '订单',
    exchange: '兑换',
    community: '航拍圈',
    noDataPopup: {
      title: '无此打卡点',
      content: '您可移至其他打卡点扫描二维码',
    },
    spotNotMatch: {
      title: '订单不适用于该打卡点',
      content: '请前往下单的打卡点扫码使用',
    },
    success: {
      title: '订单匹配成功',
      content: '您当前还没有可使用的订单哦~',
    },
    fail: {
      title: '订单匹配失败',
      content: '请重新尝试扫码或谘询客服~',
    },
    livestreamFail: {
      title: '航拍启动失败',
      content: '非常抱歉，由于本次航拍遇到阻碍无法使用。订单将会自动退款，请留意退款消息。',
    },
    notHotspotQrcode: '非有效打卡点二维码',
    exceededUsageTime: '已超过使用时间',
    expiredTicket: '当前状态无法使用',
  },
  homePage: {
    noHotspotNearby: '附近还没有打卡点，换个位置看看',
    // 列表加载态的文案。和空态分开：空态是「问过了、确实没有」，加载态是「还在问」。
    matchingNearby: '正在为你匹配最近航拍点',
    matchedNearby: '已为你匹配最近的景点',
    nearerSpot: '{name} 离你近 {gain}',
    nearerSpotPlain: '{name} 离你更近',
    nearerSpotAction: '去看看',
    allAirlines: '全部航线',
    distanceAbout: '距离约 {distance}',
    routeDisplay: '路线展示',
    noRouteData: '这条航线暂无路线数据',
    // 按钮已经叫「预订最近一班」了，这里再写一遍「最近的班次」是同一句话说两遍。
    // 这一格只需要说明右边那两个数是什么。
    nearestSession: '拍摄时间',
    // 下单进度那三步。文案对应 useReservation 里三个**真实事件**，
    // 不是编出来的假进度 —— 见 BookingStep 的注释。
    bookingLocking: '正在锁定班次',
    bookingCreated: '订单已创建',
    bookingPaying: '正在调起支付',
    bookingHint: '请勿关闭页面',
    // 「日期」那格的值：越近越用相对词，越远越用绝对日期。
    // 看到 09-15 用户得先想今天几号，看到「明天」不用想。
    today: '今天',
    tomorrow: '明天',
    sessionDate: '日期',
    sessionTime: '时间',
    // 一个景点挂了多个打卡点时，标题副行用它替掉地址。
    // 景点名已经在 H1 上了，副行要回答的是「这是哪一个、一共几个」。
    // 分隔符写进文案里而不是拼在模板上：换个语种可能换分隔符、换语序。
    hotspotIndex: '打卡点 {index}/{total}',
    swipeForMore: '下滑更多内容',
    // 滑到最后一个景点时换成这句，并且不带箭头 —— 再往下没有了，
    // 箭头会继续暗示「还能滑」。和顶部下拉那句 alreadyTop 成对。
    alreadyBottom: '已经到底啦~',
    alreadyTop: '已经到顶啦~',
    pullToRefresh: '继续拉会刷新页面',
    releaseToRefresh: '松开刷新',
    refreshing: '正在刷新',
    refreshDone: '刷新完成',
    // 后端 session_id / session_time 为 null 时（当天无可订班次）显示这句。
    // 注意 session_hour 有值不代表能订 —— 它是展示口径，售罄也会给最低价场次。
    noSessionToday: '今日已约满',
    attractionCard: {
      loginToReservation: '登录后预订航拍',
      workingTime: '营业时间',
    },
    checkinCard: {
      desc: '已开始啦~',
      buttonText: '一键航拍',
    },
    orderPopup: {
      desc: '您预约的航线已开始啦~',
      buttonText: '去航拍',
    },
    loginTipsBar: {
      desc: '立即登录大师航拍体验完成功能',
      buttonText: '去登录',
    },
    runningJourneyTipsBar: {
      desc: '您有一个大师航线正在进行中',
      buttonText: '进入',
    },
    selectFlightPage: {
      // 说「时间」不说「班次」：这个弹窗自己的两个分区标题就是 common.date
      // 和 common.time，进来的入口按钮也叫「更换时间」，卡片上那两栏同样是
      // 「日期 / 时间」。一条动线上四处用同一个词，中途不要换。
      // （英文文案本来就是 Pick a date & time，只有中文跑偏了。）
      reservationAndSelect: '选择日期与时间',
      sessionBooked: '已订满',
      selectFlight: '选择大师航线',
      flightDesc: '包含: 3-5分钟航拍，手势互动，拍照10张，手势互动',
      selectDate: '请选择预约日期',
      selectTime: '请选择使用时间',
      toChangeTicket: '去改签',
      toExchange: '去兑换',
      confirmReservation: '立即预订',
      timeType: {
        morning: '晨光绮丽',
        noon: '烈日如画',
        afternoon: '斜阳温婉',
        evening: '暮色温柔',
        night: '星辉熠熠',
      },
      reserved: '已预订',
      selected: '已选',
      soldOut: '近期售罄',
      soldOutToday: '当天售罄',
      deviceUnavailable: '暂不可预订',
      theParisianText: {
        confirmReservation: '不可在线预订',
        tips: '请联系现场工作人员',
      },
      paymentPopup: {
        desc: '请在使用时间<span style="color: #FFF; font-size: 1.4rem; font-weight: 700; margin:0 0.8rem">开始前5分钟</span>去订单页面。<br />点击【一键航拍】或【扫码航拍】使用；<br />现场若有工作人员，请直接请其协助操作。',
        desc2:
          '请<span style="color: #FFF; font-size: 1.4rem; font-weight: 700; margin:0 0.8rem">提前5分钟</span>到打卡点。<br />找现场工作人员协助操作。',
      },
      verifyPopup: {
        title: '活动码验证',
        desc: '由于活动数量有限，请联繫现场工作人员获取验证码，验证再预约。',
        placeholder: '输入6位活动码',
      },
      paymentUpdatePopup: {
        title: '支付升级中',
        desc: '请去微信/支付宝小程序下单',
      },
      otherBrowserPopup: {
        title: '去小程序预订',
        desc: '请使用小程序预订并体验大师航拍服务',
      },
    },
  },
  memoryPage: {
    title: '打卡回忆',
    checkYourRecordAfterLogin: '登录后查看打卡回忆',
    noHotpot: '还没有打卡记录',
    video: '视频',
    photo: '照片',
    zhang: '张',
    duan: '段',
    photoProcessing: '照片处理中',
    photoProcessingError: '照片处理错误',
    photoProcessingExpired: '照片处理超時',
    unlockMore: '解锁更多',
    moreTemplate: '更多模板',
    publish: '发布航拍',
    publishPlaceholder: '说说您的心情，与更多人分享吧~',
    publishSuccess: '发布成功',
    publishFailed: '发布失败',
    noRecord: '还没有打卡记录哦~',
    unlockToExperienceText: '免费体验航拍，满意再付费解锁全部权益',
    hdPhotoText: '高清照片',
    unlockToGetText: '解锁获得',
    mediaResultCodeMap: {
      ORIGINAL_VIDEO: '原视频',
      ORIGINAL_PIC: '原照片',
      CLIP_FAST_VIDEO: '快剪视频',
      PREVIEW_VIDEO: '试看视频',
      VIDEO_SUCCESS: '精剪视频',
      VIDEO_SUCCESS_BEAUTY: '精剪视频',
      FIX_CLIP: '混合剪辑',
      FIX_CLIP_BEAUTY: '混合剪辑',
      PAY_TEMP_VIDEO: '尊贵剪辑',
      PAY_TEMP_VIDEO_BEAUTY: '尊贵剪辑',
    },
    unlockedMedia: {
      title: '当前已获得',
      desc1: '您已获得高清照片',
      desc2: '，可下载',
    },
    lockedMedia: {
      title: '解锁还可获得',
      desc1: '全部权益',
      desc2: '统计中',
    },
    hotpotDetailPage: {
      title: '回忆详情',
      processing: '处理中',
      videoProcessing: '视频处理中',
      videoError: '视频文件出错，可尝试下拉刷新',
      videoFail: '视频剪辑失败，可尝试联系客服',
      videoLost: '视频丢失',
      noVideo: '无视频',
      photoProcessing: '照片处理中',
      photoEmpty: '无照片',
      noMemory: '没有回忆内容',
      downloadPhoto: '长按照片保存或分享~',
      pullrefresh: '下拉刷新',
      pullrefreshing: '正在刷新',
      easyRefresh: '松开刷新',
      refreshSuccess: '刷新完成',
      sampleVideo: '样片',
    },
    videoPage: {
      title: '视频下载',
      downloading: '下载中',
      click: '点击右上角',
      openInBrower: '在默认浏览器打开',
      text: '该页面<br />点击下载并保存视频',
    },
    cancelPublish: {
      title: '确定要取消吗?',
      desc: '将不会在"航拍圈"展示',
      skipText: '暂不',
    },
    playbackLimit: {
      title: '前往详情页完成支付',
      desc: '领取高清照片/精美视频',
      confirmText: '详情页',
    },
    sharePopup: {
      title: '共享专属回忆',
      desc: '喊上朋友扫个码，把这段回忆 “搬” 到 TA 的账号里～',
      desc2: '航拍完成起算，领取有效期为14天。',
    },
    createPoster: {
      poster: '海报',
      choosePhoto: '选择照片',
      chooseTemplate: '海报模板',
      quoteTitle: '分享语录',
      inputPlaceholder: '写下你此时此刻的心动瞬间吧~',
      generate: '生成海报',
      generating: '生成中...',
      pleaseChoosePhoto: '请选择照片',
      templateLoading: '模板加载中...',
      templateEmpty: '无模板',
      photoEmpty: '无照片',
      shareFriend: '分享好友',
      downloadPoster: '下载海报',
      close: '关闭',
      posterAlt: '生成海报',
      bgAlt: '背景图',
      templateAlt: '模板图',
      shareNotSupported: '当前浏览器不支持直接分享，请先下载海报再分享',
      generateFailed: '生成海报失败，请稍后重试',
    },
    memoryItem: {
      trimmedVideo: '精剪视频',
      trimmedVideoDescription: '免费试看10秒・解锁后可观看完整视频+下载',
      quickVideo: '快剪视频',
      quickVideoDescription: '免费完整观看・解锁后可下载',
      experienceVoucher: '体验券',
      experienceVoucherPopup: {
        subTitle: '免费体验航拍，满意再付费解锁全部权益',
        skipBtnText: '取消',
        confirmBtnText: '去解锁',
        benefitsTable: {
          type: '权益类型',
          locked: '未解锁',
          unlocked: '解锁后',
          photoTitle: '照片权益',
          photoLockedLine1: '可下载赠送的照片',
          photoUnlockedLine1: '全部高清照片下载',
          photoUnlockedLine2: '权限',
          videoTitle: '视频权益',
          videoLockedLine1: '试看视频 10 秒，',
          videoLockedLine2: '无法下载视频',
          videoUnlockedLine1: '精剪视频+快剪视频',
          videoUnlockedLine2: '（完整下载）',
          posterTitle: '分享海报',
          posterLocked: '不可使用海报功能',
          posterUnlocked: '众多海报模板，一键生成精美海报',
          communityTitle: '发布航拍圈',
          communityLocked: '不可发布到航拍圈',
          communityUnlocked: '可发布到航拍圈，分享您的精彩时刻',
        },
      },
      videoEnded: {
        playEndedText: '已播放完',
        unlockToDownloadText: '解锁后可下载视频',
        unlockToGetVideoAndDownloadText: '解锁后可获得视频下载',
        unlockToWatchText: '解锁后可观看完整视频+下载',
        replayText: '重播视频',
        unlockText: '立即解锁',
        contactText: '请联系现场工作人员解锁',
      },
    },
  },
  orderPage: {
    title: '订单',
    checkOrderAfterLogin: '登录后查看您的订单',
    noOrder: '当前还没有航拍订单',
    noClipOrder: '当前还没有视频剪辑订单',
    flightOrders: '航拍订单',
    videoOrders: '视频剪辑',
    orderId: '订单编号',
    paid: '已支付',
    fullRefund: '全额退款',
    partialRefund: '收取手续费{value}%, 退款',
    shadow: '未支付',
    orderDetailPage: {
      title: '订单详情',
      goThere: '去这里',
      paymentTime: '支付时间',
      exchangeTime: '兑换时间',
      startTime: '开始时间',
      endTime: '结束时间',
      refundDetails: '退款明细',
      paymentDetails: '支付明细',
      refundPrice: '退款金额',
      totalPrice: '总价',
      partialRefund: '本次退款需收取手续费{value}%',
      changeTicketLimit: '改签已达上限次数',
      awaitingUseNote: {
        title: '待使用',
      },
      usedNote: {
        title: '已使用',
        desc: '感谢您使用，期待再次相遇',
      },
      expiredNote: {
        title: '已过期',
        desc: '已超过报到有效时限',
      },
      unfinishedNote: {
        title: '未完成',
        desc: '航拍失败，建议改签后再试',
      },
      cancelledNote: {
        title: '已取消',
        desc: '因天气原因无法使用，已退款',
      },
      refundsProgressNote: {
        title: '退款中',
        desc: '已提交退款申请，系统核实中',
      },
      refundFailureNote: {
        title: '退款失败',
        desc: '不符合退款条件，申请被驳回',
      },
      refundedNote: {
        title: '已退款',
        desc: '金额原路退回，请留意短信提示',
      },
      deviceErrorNote: {
        title: '未完成',
        desc: '因航拍遇到阻碍</br>支付金额將自动退款，请耐心等待',
      },
      skypathNotFound: '航线已下线',
      refundApplicationPopup: {
        title: '退款申请',
        dontWanaUse: '行程有变故/不想用了',
        nonFlyable: '天气因素/空域管制/设备故障',
        unusedOvertime: '超時未使用',
        hazardousConditions: '使用过程中遇危难情况，未完成航拍',
        systemCancel: '航拍失败，订单未完成',
        explanation: '说明原因状况',
        detailsDesc: '请这裡填写原因以便我们了解情况',
        uploadPicture: '上传图片',
        parentheses: '(提高审核通过率，最多4张)',
        longText:
          '由于无人机飞行中会出现突发性的危险情况，需要终止航拍，本次退款将原路返还到您的支付账号上。提交申请后请留意消息通知。',
        cancelledText: '由于系统繁忙导致航拍失败，系统审核通过后，款项会原路退回。',
      },
      quesstionPopup: {
        title: '是否确认退款？',
        subTitle: '本次申请需要额外手续费{value}%作为商家损失费，<br />是否确定退款？',
      },
      feedbackPopup: {
        title: '提交成功',
        subTitle: '系统正在加速核实中',
        description: '审核通过后，将在7个工作日内原路退回。',
      },
    },
    orderStatus: {
      NOTIFICATION_TYPE_UNKNOWN: '未知',
      TICKET_TYPE_UNSPECIFIED: '未知',
      TICKET_TYPE_NEW: '待使用',
      TICKET_TYPE_COMPLETED: '已使用',
      TICKET_TYPE_ABORTED: '已使用',
      TICKET_TYPE_CHECKED: '待使用',
      TICKET_TYPE_EXPIRED: '已过期',
      TICKET_TYPE_CANCELLED: '未完成',
      TICKET_TYPE_DRC_INIT_FAILED: '未完成',
      TICKET_TYPE_LIVE_STREAM_FAILED: '未完成',
      TICKET_TYPE_LIVE_STREAM_PUSHED: '进行中',
      TICKET_TYPE_BAD_WEATHER: '已取消',
      TICKET_TYPE_REFUND_REQUESTED: '退款中',
      TICKET_TYPE_REFUND_REJECTED: '退款失败',
      TICKET_TYPE_REFUND_ACCEPTED: '已退款',
      TICKET_TYPE_SHADOW: '未支付',
      UNKNOWN: '未知',
      UNPAID: '未支付',
      UNUSED: '待使用',
      USED: '已使用',
      EXPIRED: '已过期',
      REFUNDING: '退款中',
      REFUNDED: '已退款',
      REFUND_REJECTED: '退款失败',
      LIVE_STREAM_PUSHED: '进行中',
      CHECKED: '已报到',
      UNFINISHED: '未完成',
    },
    clipOrderStatus: {
      EDIT_PENDING: '待剪辑',
      EDIT_COMPLETED: '已剪辑',
    },
  },
  profilePage: {
    switchLanguage: '切换语言',
    clickLogin: '点击登录',
    service: '联系客服',
    referrer: '推荐官',
    becomeReferrerPopup: {
      title: '成为推荐官',
      subTitle: '邀请新用户下单能获取奖励。',
    },
    canceledReferrerPopup: {
      title: '已取消资格',
      subTitle: '如有疑惑请联系客服。',
    },
    referrerToast: {
      pendingReview: '审核中，请耐心等候',
      submitSuccess: '申请提交成功',
      toMiniProgramUse: '请到小程序使用相关功能',
      toMiniProgramSettle: '请到小程序申请结算',
    },
    referrerReviewStatus: {
      PENDING: '审核中',
      REJECTED: '审核不通过',
      CANCELLED: '已取消资格',
      DISABLED: '已取消资格',
    },
    userQrcodePopup: {
      share: ['点击右上角', '分享'],
      tip: '扫一扫二维码，邀请加入大师航拍',
    },
    bindShareMemoryPopup: {
      title: '您有未体验的航拍',
      buttonText1: '去体验航拍',
      buttonText2: '领取已有视频/照片',
    },
    claimSuccessPopup: {
      title: '领取成功',
      desc: '已将 视频/照片 记录在《我的-回忆》中',
    },
    SHARE_EXIST: {
      title: '回忆已收入囊中',
      desc: '这份回忆你已经领过啦，不用重复领取哦～',
      icon: 'normal',
    },
    SHARE_OWN_MEMORY_FORBIDDEN: {
      title: '领取提示',
      desc: '无法领取自己的回忆（视频/照片）哦~',
      icon: 'warning',
    },
    SHARE_ORDER_STATUS_ERROR: {
      title: '领取提示',
      desc: '无法领取该订单的回忆（视频/照片）哦~',
      icon: 'warning',
    },
    SHARE_EXPIRED: {
      title: '领取超时',
      desc: '已超过14天领取有效期，无法领取~',
      icon: 'error',
    },
    claimFailedPopup: {
      title: '领取失败',
      desc: '抱歉，领取时间已过，无法领取',
    },
    notice: '系统消息',
    setting: '设置',
    wechatUser: '微信用户',
    toutiaoUser: '抖音用户',
    aliUser: '支付宝用户',
    anonymousUser: '匿名用户',
    phoneNumberText: '请用小程序授权手机号',
    exchangeInputError: '请输入正确的兑换码',
    scanQRCodeFailed: '扫描兑换码失败',
    exchangeInputPlaceholder: '请输入兑换码',
    servicePopup: {
      title: '联系客服',
      desc: '长按二维码识别<br />为您提供快捷专属的谘询服务',
    },
    loginPopup: {
      content: '登录后查看详细',
    },
    noticePage: {
      title: '系统消息',
      viewDetails: '查看详情',
      successfulBooking: '预订成功',
      orderCanceled: '订单已取消',
      refundRequestSubmittedSuccessfully: '退款申请提交成功',
      refundRequestFailed: '退款申请失败',
      refundRequestApproved: '退款申请已通过',
      noNotice: '还没有消息记录',
      noticeDetailsPage: {
        title: '消息详情',
      },
    },
    switchLanguagePage: {
      title: '切换语言',
      switchComplete: '切换完成',
    },
    settingPage: {
      title: '设置',
      account: '账号',
      about: '关于',
      changePhoneNumber: '更改手机号',
      serviceAgreement: '用户协议',
      privacyPolicy: '隐私政策',
      AboutMss: '关于大师航拍',
      writeoffAccount: '注销账号',
      popup: {
        title: '确定注销账号？',
        subTitle:
          '注销成功后，将无法登录或以任何方式使用当前账号，且后续无法恢复，请关注以下重要提醒：',
        deregisteredSuccessfully: '注销成功',
        contenth3: '本次注销具体包括如下信息',
        contentp1:
          '1.注销账号后以下信息将依照相关法律规定及协议约定，清空且无法恢复，包括个人信息、大师航拍账号信息、订单信息、航拍视频/照片等。',
        contentp2: '2.在使用大师航拍服务中产生的交易金额，将不给予退还。',
      },
    },
    serviceAgreementPage: {
      title: '用户协议',
    },
    privacyPolicyPage: {
      title: '隐私政策',
    },
    aboutMssPage: {
      title: '关于大师航拍',
      desc: '《旅游景点共享无人机系统-大师航拍》：<br />是专为旅游爱好者提供的全自动共享无人机服务。',
      slogan: '让世界看见中国的美',
    },
    changePhoneNumberPage: {
      title: '更改手机号',
      newPhoneNumber: '请输入新手机号码',
      verifyCurrentPhone: '验证当前手机并解绑',
      originalPhoneNumber: '请输入原手机号码',
      modifyPhoneBinding: '绑定新手机号',
      modifyPhoneBindingSuccess: '绑定新手机号成功',
      tips: '点击下一步即爲解绑当前手机号',
      successToast: {
        title: '更改成功',
      },
      errorToast1: {
        title: '手机号已被使用',
      },
      errorToast2: {
        title: '短信服务错误',
      },
    },
  },
  loginPage: {
    loginLoad: '登录中...',
    loginByWechat: '微信一键登录',
    acceptInvitationLogin: '接受邀请并登录',
    noLogin: '暂不登录',
    weChatAuthorizedLogin: '微信授权登录',
    phoneLogin: '手机登录',
    phoneLoginTips: '新用户验证登录即注册',
    tipsText: '我已阅读并同意',
    userAgreement: '《用户协议》',
    privacyPolicy: '《隐私政策》',
    verificationCodeSend: '验证码已发送',
    verificationCodeExpired: '验证码已失效',
    verificationCodeError: '验证码错误',
    netWorkError: '网络异常, 请稍后重试',
    popup: {
      title: '协议/政策',
      content:
        '为了更好的保障您的合法权益，请您阅读并同意以下协议<span style="color: #016BFF"><span class="_terms">《用户协议》</span> & <span class="_privacy">《隐私政策》</span></span>',
    },
    referrer: {
      title: '邀请人',
      notNewUser: '你已不是新用户，无法被邀请',
      success: '你已成功被邀请',
      unableInviteMyself: '无法邀请自己',
    },
    smsCodePopup: {
      title: '请用上一个短信码登录',
      subTitle: '当天短信码获取到达上限',
    },
  },
  bindingPhonePage: {
    tips: '首次登录需要绑定您的手机号',
    phone: '请输入手机号',
    verificationCode: '请输入短信验证码',
    getCode: '获取验证码',
    getCodeAgain: '重新获取',
    bindingPhone: '绑定手机',
    phoneError: '请输入正确位数的手机号',
    areaCodeError: '请输入正确的区号',
    noMatchCountry: '未找到匹配的国家',
    searchAreaCode: '搜索区号',
    unbindPhoneError: '该号码与绑定号码不一致，请重新输入',
    verificationCodeError: '验证码错误，请重新输入',
    successToast: {
      title: '绑定成功',
    },
    toast1: {
      title: '手机号已被绑定',
      content: '请更换手机号再尝试',
    },
    toast2: {
      title: '短信验证码错误',
      content: '请重新获取验证码',
    },
  },
  wechatPage: {
    title: '请使用微信访问<span style="color: #42BDFF">大师航拍</span>',
    desc1: '用微信“扫一扫”，现场扫描打卡点上的二维码即可进入大师航拍官网。',
    desc2: '在当前页面截图发送到微信聊天框，长按识别二维码添加公众号，在公众号进入官网。',
  },
  tutorialsPage: {
    step1: {
      title: '航拍准备开始啦',
      description: '为保证良好的航拍体验，请确保已站在脚印范围',
    },
    step2: {
      title: '拍照操作',
      description1: '滑动操控干可控制摄影角度，调整画面位置。',
      description2: '上下拖动滚轴可放大/缩小，控制画面变焦。',
      description3: '大师角度',
      description4: '点击回到系统设置好的最美镜头位置。',
      description5: '即将拍照',
      description6: '拍照',
      description7: '点拍照后会进入3秒面延时拍照',
    },
    step3: {
      title: '实时播报',
      description: '建议调大手机音量，留意语音提示',
    },
    step4: {
      title: '中断航拍',
      description1: '点击“中断”按钮退出本次航拍，视为航拍结束。',
      description2: '当前拍摄记录会保存在回忆',
      description3:
        '如航拍中，无人机因外部因素遇到飞行危险，系统会自动中断结束本次航拍，可到订单申请退款。',
    },
    tutorialsPopup: {
      title: '航拍准备开始啦~',
      subTitle: '为保证良好的航拍体验</br>请确保已站在脚印范围',
      buttonText: '我已在脚印范围内',
    },
    guideline: '指引',
    yourReservation: '您的预订航拍',
    started: '已开始',
    asaPossible: '请尽快启动航拍',
    yourReservationStill: '还有',
    keepInMind: '开始',
  },
  aerialPage: {
    resume: {
      flying: '航拍进行中',
      flyingWithTime: '航拍进行中 · 已飞 {time}',
      backToFlight: '返回航拍',
    },
    TAKE_OFF: '起飞',
    GO_HOME: '返航',
    FLYING: '航行',
    RECORDING: '录影',
    USER_PHOTO: '自拍',
    CONTROL: '控飞',
    SYSTEM_PHOTO: '系统拍照',
    HOVERING_CONTROL: '悬停控飞',
    DRONE_STARTUP: '无人机开机',
    DOCK_COVER_OPEN: '开舱',
    PREPARE_FOR_TAKE_OFF: '起飞准备',
    TOUCH_SCREEN_SHOW_LIVE: '轻触屏幕展示画面',
    LIVE_SUCCESS: '无人机画面连接成功',
    POOR_NETWORK_TOUCH_RECONNECT: '当前网络不佳，点我重新连接',
    seizePower: '控制权限已被接管',
    seizePowerBtn: '重新控制',
    connecting: '连接中...',
    airportLive: {
      connecting: '机场连接中',
      poorNetwork: '网络不稳，重新连接',
    },
    step1: {
      name: '起飞',
    },
    step2: {
      name: '自拍及操控',
    },
    step3: {
      name: '航拍',
    },
    shotTips: '即将拍照',
    flightPoints: '航线节点',
    flightInitTips: '无人机启动中',
    flightRecordTips: '航线正在录影中，手动录影不可用。',
    flightFinishPopup: {
      statusText: '您已完成本次航拍之旅',
      subTitle:
        '预计<span style="color: #FFF; font-size: 1.8rem; font-weight: 700; line-height: 2.6rem; margin:0 0.8rem">10分钟后</span>图片视频会处理完成<br />并记录在《回忆》中，请耐心等待~',
      subscribedText: '处理完通知我',
    },
    flightErrorPopup: {
      statusText: '航拍失败',
      subTitle: '请<span style="color: #016BFF">改签</span>后重飞，或到订单详情申请退款。',
      confirmBtnText: '去改签',
      cancelBtnText: '去退款',
    },
    autoTakePhotoText: '准备进入<br />自动拍照啦~',
    networkAnomalyPopup: {
      title: '网络连接异常',
      subTitle: '抱歉，当前网络连接出现异常<br />请重新连接或返回重新启动航拍',
      confirmBtnText: '重新连接',
    },
    stopFlightPopup: {
      title: '是否强制中断航拍？',
      subTitle: '强制中断航拍将视为完成本次航拍，当前拍摄<br />内容会保存到《回忆》中。',
      content: '强制停止航拍将不能申请退款',
    },
    droneStartFailPopup: {
      title: '启动航拍失败',
      subTitle: '机场异常，请稍后重试！',
    },
    droneLowBattery: {
      title: '启动航拍失败',
      subTitle: '无人机充电中，请稍后重试！',
    },
    terminateFlightPopup: {
      title: '航拍终止提示',
      subTitle: '抱歉，由于无人机飞行中遇到危险情况，系统将<br />终止本次飞行任务。',
      content: '您可到订单详情中申请退款',
    },
    droneExecutingPopup: {
      title: '启动航拍失败',
      subTitle: '无人机航拍中，请稍后重试！',
      cancelBtnText: '返回',
      confirmBtnText: '重试',
    },
    thisLineFlyingPopup: {
      title: '启动航拍失败',
      subTitle: '航线繁忙，请稍后重试！',
      cancelBtnText: '返回',
      confirmBtnText: '重试',
    },
    noRtkPopup: {
      title: '启动航拍失败',
      subTitle: '机场未标定，请稍后重试！',
      cancelBtnText: '返回',
      confirmBtnText: '重试',
    },
    autoReturnPopup: {
      title: '航拍终止提示',
      subTitle:
        '航线异常，无人机自动返航。<br />请<span style="color: #016BFF">改签</span>后重飞，或到订单详情申请退款。',
      skipBtnText: '后自动结束',
    },
    recoveryFailPopup: {
      title: '航拍终止提示',
      subTitle:
        '无人机脱离航线，结束航拍。<br />请<span style="color: #016BFF">改签</span>后重飞，或到订单详情申请退款。',
      skipBtnText: '后自动结束',
    },
    takeOffFailedPopup: {
      title: '启动航拍失败',
      subTitle: '无人机指令异常，系统已自动退款！',
    },
    takeOffNoHeartbeatPopup: {
      title: '启动航拍失败',
      subTitle: '机场网络异常，系统已自动退款！',
    },
    takeOffNoFilePopup: {
      title: '启动航拍失败',
      subTitle: '航线异常，系统已自动退款！',
    },
    autoRefundPopup: {
      title: '启动航拍失败',
      subTitle: '订单即将超时，系统已自动退款！',
    },
    unKnownPopup: {
      title: '启动航拍失败',
      subTitle: '系统繁忙，请稍后重试！',
    },
    beforeScheduledTimePopup: {
      title: '启动航拍失败',
      subTitle: '订单预定时间未到，请稍后重试！',
    },
    liveStreamFailedPopup: {
      title: '启动航拍失败',
      subTitle: '直播失败，请稍后重试！',
    },
    noInTaskPopup: {
      title: '无人机返航中',
      subTitle: '上一任务结束，正在回舱，请稍等再启动！',
    },
    moreThanOneMinuteFailedPopup: {
      title: '启动航拍失败',
      subTitle: '机场网络异常，建议重试或去<span style="color: #016BFF">改签</span>后再试！',
      cancelBtnText: '去改签',
      confirmBtnText: '重试',
    },
    lessThanOneMinuteFailedPopup: {
      title: '启动航拍失败',
      subTitle:
        '订单即将超时，建议你<span style="color: #016BFF">改签</span>后再试！</br>或到订单详情申请退款。',
      cancelBtnText: '去退款',
      confirmBtnText: '去改签',
    },
    notCompleteStartPopup: {
      title: '航拍失败',
      subTitle: '抱歉，将自动退款，原路退回账户上。',
    },
    skipFlightPopup: {
      title: '跳过节点提示',
      subTitle: '跳过将不能再体验此节点功能（即当前节点时间）',
      content: '请谨慎确认',
      confirmBtnText: '继续体验',
      cancelBtnText: '确认跳过',
    },
    flightDescription: {
      default: '无人机启动中，请耐心等待~',
      d0: '无人机正在从机场飞出',
      d1: '就位拍照',
      d2: '就位拍摄',
    },
    loadingToast: {
      photo: '已进入拍照',
      recording: '已进入航拍',
      exit: '航拍结束，正在退出',
    },
    switchText: {
      takePhoto: '自拍',
      control: '操控',
    },
    SKYSHOT_JOURNEY_INTERRUPTED:
      '机场异常，建议重试或去<span style="color: #016BFF">改签</span>后再试！',
    SKYSHOT_JOURNEY_LIVE_STREAM_FAILED:
      '直播失败，建议重试或去<span style="color: #016BFF">改签</span>后再试！',
    SKYSHOT_JOURNEY_PUSH_LIVE_STREAM_FAILED:
      '直播失败，建议重试或去<span style="color: #016BFF">改签</span>后再试！',
    SKYSHOT_JOURNEY_EXECUTING: '无人机航拍中，请稍后再重试！',
    SKYSHOT_JOURNEY_BATTERY_NOT_ENOUGH:
      '无人机充电中，建议重试或去<span style="color: #016BFF">改签</span>后再试！',
    SKYSHOT_JOURNEY_TAKEOFF_FAILED:
      '无人机指令异常，建议重试或去<span style="color: #016BFF">改签</span>后再试！',
    SKYSHOT_JOURNEY_TAKEOFF_NO_HEARTBEAT:
      '机场网络异常，建议重试或去<span style="color: #016BFF">改签</span>后再试！',
    SKYSHOT_JOURNEY_TAKEOFF_NO_FILE:
      '航线异常，建议重试或去<span style="color: #016BFF">改签</span>后再试！',
    SKYSHOT_JOURNEY_UNKNOWN: '系统繁忙，建议稍后再试！',
    SKYSHOT_JOURNEY_AGENT_NO_HEARTBEAT:
      '边缘设备网络异常，建议重试或去<span style="color: #016BFF">改签</span>后再试！',
    SKYSHOT_JOURNEY_DOCK_NO_HEARTBEAT:
      '机场网络异常，建议重试或去<span style="color: #016BFF">改签</span>后再试！',
    // 不是网络问题：航线绑的前置机和机场绑的前置机对不上，重试和改签都不会好（mss-cloud#66）
    SKYSHOT_JOURNEY_AGENT_DOCK_NOT_BOUND:
      '该航线暂不可用，请联系现场工作人员协助处理！',
    // 机场在线但没关联无人机：同样是配置问题，重试和改签都不会好（mss-cloud#93 / h5#24）
    SKYSHOT_JOURNEY_DOCK_DRONE_NOT_BOUND:
      '该机场暂未关联无人机，请联系现场工作人员协助处理！',
    TAKE_OFF_TIME_OUT: '超时未起飞，建议重试或去<span style="color: #016BFF">改签</span>后再试！',
    START_FLY_CMD_FAIL:
      '下发起飞指令失败，建议重试或去<span style="color: #016BFF">改签</span>后再试！',
    DRONE_NOT_IN_DOCK:
      '无人机不在机舱内，建议重试或去<span style="color: #016BFF">改签</span>后再试！',
    PICK_DOCK_FAIL: '连接机场失败，建议重试或去<span style="color: #016BFF">改签</span>后再试！',
    DJI_UPLOAD_LOG:
      '机场正在上传日志，建议重试或去<span style="color: #016BFF">改签</span>后再试！',
    stillTime: '剩余时间',
    shootInSuccession: '连拍',
    joystickControl: {
      up: '上升',
      down: '下降',
      left: '左转',
      right: '右转',
    },
    droneControl: {
      up: '前进',
      down: '后退',
      left: '左飞',
      right: '右飞',
    },
    liveQuality: '直播</br>画质',
    liveQualityValue: {
      auto: '自适应',
      smooth: '流畅',
      standard: '标准',
      hd: '高清',
      uhd: '超清',
    },
    controlTheGimbal: '滑动屏幕控制云台',
    pausedControlTheGimbal: '已暂停，进入悬停控飞',
    gimbal: '云台',
    refresh: '刷新',
    interrupted: '终止',
    live: '直播中',
  },
  actionsPage: {
    actionResolutionFail: '动作解析失败',
    paramsResolutionFail: '参数解析失败',
  },
  personalPage: {
    title: '个人资料',
    signature: {
      title: '编辑签名',
      placeholder: '这个家伙很酷，没有写签名',
    },
  },
  community: {
    title: '评论',
    likeFailed: '点赞失败，请重试',
    unlikeFailed: '取消点赞失败，请重试',
    commentTitle: '发表评论',
    commentPlaceholder: '说说你的想法...',
    commentSuccess: '评论发表成功',
    commentFailed: '评论发表失败，请重试',
    noComment: '还没有评论哦~',
    shootSimilar: '拍同款',
  },
  common: {
    waylineSummary: {
      title: '包含',
      desc: '3-5分钟航拍，手势互动，拍照10张，手势互动',
    },
    unknownError: '未知错误',
    expand: '展开',
    collect: '收起',
    hotspot: '打卡点',
    copy: '复制',
    copySuccess: '复制成功',
    copyFailed: '复制失败',
    verifySuccess: '验证成功',
    verifyFailed: '验证失败',
    loadError: '加载失败，点击重试',
    loadFailed: '加载失败',
    retry: '重试',
    useDate: '使用日期',
    useTime: '使用时间',
    date: '日期',
    time: '时间',
    noMore: '没有更多啦~',
    noData: '暂无数据',
    noContent: '当前还没有内容哦~',
    unset: '未设置',
    experienceNow: '马上体验',
    alreadyExperience: '已体验',
    myMemory: '我的回忆',
    purchaseNotes: {
      title: '购买须知',
      note1: '“使用时间”的前5分钟即可提前使用航拍；',
      note2:
        '进入订单页点击【一键航拍】或【扫码航拍】使用；<br />现场若有工作人员，请直接请其协助操作。',
      note3: '超过“使用时间”5分钟后，不能再使用航拍 ，且不可退改，请确认好时间后再行购买。',
      note4: '请找现场工作人员协助操作。',
      note5: '使用時間之前5分鐘至後5分鐘，例如12:15，<br />12:10- 12:20可使用。',
      note6: '超过使用时间区间5分钟后将不可使用，视为放弃本次航拍。',
    },
    refundRules: {
      title: '退款规则',
      refundRequestTimeToUse: '申请退款距使用时间',
      unusedOvertime: '超时未使用（7个自然日内申请）',
      unusedOvertime2: '超时未使用（超过7个自然日未申请）',
      otherReason: '天气因素/空域管制/设备故障',
      handlingFee: '手续费',
      verification: '核实通过',
      noRefund: '不予退款',
    },
    termsOfUse: {
      title: '使用须知',
      howToUse: {
        title: '如何使用',
        description:
          '进入订单页点击【一键航拍】或【扫码航拍】使用；<br />现场若有工作人员，请直接请其协助操作。',
        description2: '请找现场工作人员协助操作。',
      },
      timeOfUse: {
        title: '使用时间',
        description: '使用时间前5分钟到后5分钟，例如8:15，8:10 - 8:20可使用。',
        description2: '使用时间之前5分钟至后5分钟，例如12:15，12:10- 12:20<br />可使用。',
      },
      timeoutUnused: {
        title: '超时未使用',
        description: '超过使用时间5分钟后将不可使用，视为放弃本次航拍。',
        description2: '超过使用时间区间5分钟后将不可使用，视为放弃本次航拍。',
      },
      changeTicket: {
        title: '改签说明',
        description:
          '1. 凡遇到航拍失败的情况可免费改签，最多改签5次。<br />2. 航拍失败后7个自然日内未申请改签或退款，系统将自动<br />&nbsp&nbsp&nbsp&nbsp退款并关闭订单。',
      },
    },
    servicePopup: {
      title: '微信客服',
      content: '长按二维码识别</br>为您提供快捷专属的谘询服务',
    },
    authFailedPopup: {
      title: '账号下线通知',
      subtitle: '当前账号已超过登录时效，请重新登录。',
    },
    accountFrozenPopup: {
      title: '账号已被冻结',
      subtitle: '该账号存在违规操作，已被冻结！</br>如有疑惑，请联系客服。',
    },
    h: '时',
    m: '分',
    hour: '小时',
    hourShort: '时',
    minuteShort: '分',
    minute: '分钟',
    day: '天',
    ago: '前',
    just: '刚刚',
    more: '更多',
    about: '约',
    paymentSuccessful: '预订成功',
    changeTicketSuccess: '改签成功',
    changeTicketFailed: '改签失败',
    exchangeSuccess: '兑换成功',
    exchangeFailed: '兑换失败',
    exchangeFailedDescription: '还没有回忆视频/照片，请稍后再领取。',
    exchangeFailedDescriptionExpired: '该卡券已过期，请使用其他卡券。',
    sessionNotAvailable: '当前时间已被预订',
    subscribe: '订阅通知',
    subscribed: '已订阅通知',
    subscribeLoad: '订阅中...',
    subscribeError: '订阅失败',
    paymentSuccessfulSubscribe: '到点通知我',
    current: '当前',
    backToToday: '回到<br />今天',
    Mon: '周一',
    Tue: '周二',
    Wed: '周三',
    Thu: '周四',
    Fri: '周五',
    Sat: '周六',
    Sun: '周日',
    Jan: '一月',
    Feb: '二月',
    Mar: '三月',
    Apr: '四月',
    May: '五月',
    Jun: '六月',
    Jul: '七月',
    Aug: '八月',
    Sep: '九月',
    Oct: '十月',
    Nov: '十一月',
    Dec: '十二月',
    male: '男',
    female: '女',
    hide: '不显示',
    nickname: '昵称',
    phone: '手机',
    gender: '性别',
    saveSuccess: '保存成功',
    saveFailed: '保存失败',
    pleaseTryAgain: '请重试',
    requestFailed: '请求失败，点击重新加载',
    loading: '加载中',
    mapLoading: '地图加载中',
    mapLoadFailed: '地图加载失败',
    bg: '背景图',
    pullUpLoadMore: '上拉加载更多',
    scan: '扫一扫',
    scanSubTitle: '将二维码放入框内，即可自动扫描',
    weixin: '微信',
    alipay: '支付宝',
    signature: '签名',
    originalVideo: '原视频',
    originalImage: '原照片',
    publishedCommunity: '已发布航拍圈',
    publishToCommunity: '发布到航拍圈',
    disabledPublishCommunity: '不可发布航拍圈',
    viewOriginalImage: '查看原图',
    viewThumbnail: '效果图',
    later: '稍后',
  },
  buttonText: {
    confirm: '确定',
    cancel: '取消',
    back: '返回',
    backTryAgain: '返回重试',
    nextStep: '下一步',
    reservation: '预订',
    confirmChangeTicket: '立即改签',
    confirmExchange: '立即兑换',
    viewOrder: '查看订单',
    aerialPhotographyGuide: '航拍指引',
    agreeAndLogin: '同意并登录',
    toLogin: '去登录',
    loginToReserve: '登录后预订航拍',
    reserveNow: '马上预订',
    downloadVideo: '下载视频',
    downloading: '下载中',
    downloadAgain: '重新下载',
    download: '下载',
    share: '共享',
    gotIt: '我知道了',
    requestRefund: '申请退款',
    contactCustomerService: '联系客服',
    noApplication: '暂不申请',
    submitApplication: '提交申请',
    logout: '退出登录',
    confirmSwitching: '确定切换',
    completionBonding: '完成绑定',
    agreeAndBind: '同意并绑定',
    login: '登录',
    notApply: '不申请了',
    identifyAndApply: '确定并申请',
    thinkAbout: '我再想想',
    definitiveCancellation: '确定注销',
    startupAerial: '启动航拍',
    aerialInfoSynchronized: '航拍信息同步中',
    viewMemory: '查看回忆',
    breakAerial: '中断航拍',
    breakAerialBr: '中断<br />航拍',
    continueAerial: '继续航拍',
    scanRightNow: '立即航拍',
    oneClickAerial: '一键航拍',
    enterAerial: '进入航拍',
    scanAerial: '扫码航拍',
    changeTicket: '改签',
    toChangeTicket: '去改签',
    rescanQrcode: '重新扫码',
    noStream: '画面卡<br />请点我',
    confirmModification: '确定更改',
    skip: '跳过',
    prev: '上一页',
    next: '下一页',
    voucher: '卡券兑换',
    longPressSaveQrcode: '长按保存二维码',
    saveImage: '保存图片',
    shareFriends: '分享给好友',
    exchange: '兑换',
    toAppointment: '去预订',
    // 原本是「预约拍 / 现在拍」。「现在拍」承诺了一件按钮控制不了的事 ——
    // 它实际做的是「下单最近的那一班」，而那一班可能是明早 10:00
    // （Zack 凌晨 00:43 截图：最近班次 09-15 10:00，按钮却写着「现在拍」）。
    // 改成动宾结构，说清楚点下去会发生什么；这颗按钮后面接的是支付。
    // 两颗按钮跟左边的「拍摄时间」标签串成一句话：
    //   拍摄时间 今天 10:55 → [更换时间] [预订最近一班]
    // 左边指着那个时间说「换一个」，右边指着那一班说「就订它」。
    //
    // 首字刻意不同（更 / 预）。一度试过「预约班次 / 预订最近班次」，
    // 「预约」和「预订」在中文里几乎同义，眼睛要读到第三四个字才分得出差别。
    //
    // 右边是「最近一班」不是「最近」——「最近」是形容词，单用缺宾语，
    // 「预订最近」在中文里是半句话。
    appointmentShoot: '更换时间',
    shootNow: '预订最近一班',
    purchase: '购买',
    gain: '获取',
    loginToBook: '登录预订',
  },
  bookingCard: {
    oneClickStart: '一键启动',
    loginToBook: '登录后预订',
    bookNow: '马上预订',
    scanAerial: '扫码航拍',
    contactStaff: '请联系工作人员',
    moreOrders: '更多订单',
  },
  other: {
    exitPreview: '秒后退出预览',
  },
  countries: {
    // 亚洲地区
    china: '中国大陆',
    hongkong: '中国香港',
    taiwan: '中国台湾',
    macau: '中国澳门',
    singapore: '新加坡',
    japan: '日本',
    thailand: '泰国',
    malaysia: '马来西亚',
    philippines: '菲律宾',
    australia: '澳大利亚',
    india: '印度',
    southkorea: '韩国',
    vietnam: '越南',
    indonesia: '印度尼西亚',
    myanmar: '缅甸',
    cambodia: '柬埔寨',
    laos: '老挝',
    brunei: '文莱',
    mongolia: '蒙古',
    kazakhstan: '哈萨克斯坦',
    kyrgyzstan: '吉尔吉斯斯坦',
    uzbekistan: '乌兹别克斯坦',
    tajikistan: '塔吉克斯坦',
    turkmenistan: '土库曼斯坦',
    afghanistan: '阿富汗',
    pakistan: '巴基斯坦',
    bangladesh: '孟加拉国',
    srilanka: '斯里兰卡',
    maldives: '马尔代夫',
    nepal: '尼泊尔',
    bhutan: '不丹',
    iran: '伊朗',
    iraq: '伊拉克',
    israel: '以色列',
    jordan: '约旦',
    lebanon: '黎巴嫩',
    syria: '叙利亚',
    saudiarabia: '沙特阿拉伯',
    uae: '阿联酋',
    qatar: '卡塔尔',
    kuwait: '科威特',
    bahrain: '巴林',
    oman: '阿曼',
    yemen: '也门',

    // 欧洲地区
    russia: '俄罗斯',
    uk: '英国',
    france: '法国',
    germany: '德国',
    italy: '意大利',
    spain: '西班牙',
    portugal: '葡萄牙',
    netherlands: '荷兰',
    belgium: '比利时',
    switzerland: '瑞士',
    austria: '奥地利',
    sweden: '瑞典',
    norway: '挪威',
    denmark: '丹麦',
    finland: '芬兰',
    poland: '波兰',
    czech: '捷克',
    hungary: '匈牙利',
    romania: '罗马尼亚',
    bulgaria: '保加利亚',
    croatia: '克罗地亚',
    serbia: '塞尔维亚',
    slovenia: '斯洛文尼亚',
    slovakia: '斯洛伐克',
    estonia: '爱沙尼亚',
    latvia: '拉脱维亚',
    lithuania: '立陶宛',
    greece: '希腊',
    turkey: '土耳其',
    ukraine: '乌克兰',
    belarus: '白俄罗斯',
    moldova: '摩尔多瓦',
    albania: '阿尔巴尼亚',
    macedonia: '马其顿',
    montenegro: '黑山',
    bosnia: '波黑',
    ireland: '爱尔兰',
    iceland: '冰岛',
    luxembourg: '卢森堡',
    malta: '马耳他',
    cyprus: '塞浦路斯',
    monaco: '摩纳哥',
    liechtenstein: '列支敦士登',
    andorra: '安道尔',
    sanmarino: '圣马力诺',
    vatican: '梵蒂冈',

    // 北美洲
    us: '美国',
    canada: '加拿大',
    mexico: '墨西哥',
    guatemala: '危地马拉',
    belize: '伯利兹',
    honduras: '洪都拉斯',
    elsalvador: '萨尔瓦多',
    nicaragua: '尼加拉瓜',
    costarica: '哥斯达黎加',
    panama: '巴拿马',
    cuba: '古巴',
    jamaica: '牙买加',
    haiti: '海地',
    dominican: '多米尼加',
    puertorico: '波多黎各',

    // 南美洲
    brazil: '巴西',
    argentina: '阿根廷',
    chile: '智利',
    colombia: '哥伦比亚',
    peru: '秘鲁',
    venezuela: '委内瑞拉',
    ecuador: '厄瓜多尔',
    bolivia: '玻利维亚',
    paraguay: '巴拉圭',
    uruguay: '乌拉圭',
    guyana: '圭亚那',
    suriname: '苏里南',
    frenchguiana: '法属圭亚那',

    // 非洲
    southafrica: '南非',
    egypt: '埃及',
    nigeria: '尼日利亚',
    kenya: '肯尼亚',
    morocco: '摩洛哥',
    algeria: '阿尔及利亚',
    tunisia: '突尼斯',
    libya: '利比亚',
    sudan: '苏丹',
    ethiopia: '埃塞俄比亚',
    ghana: '加纳',
    tanzania: '坦桑尼亚',
    uganda: '乌干达',
    zimbabwe: '津巴布韦',
    zambia: '赞比亚',
    botswana: '博茨瓦纳',
    namibia: '纳米比亚',
    angola: '安哥拉',
    mozambique: '莫桑比克',
    madagascar: '马达加斯加',
    mauritius: '毛里求斯',
    seychelles: '塞舌尔',
    comoros: '科摩罗',
    djibouti: '吉布提',
    somalia: '索马里',
    eritrea: '厄立特里亚',
    rwanda: '卢旺达',
    burundi: '布隆迪',
    malawi: '马拉维',
    lesotho: '莱索托',
    swaziland: '斯威士兰',
    cameroon: '喀麦隆',
    centralafrica: '中非',
    chad: '乍得',
    congo: '刚果',
    democraticcongo: '刚果民主共和国',
    gabon: '加蓬',
    equatorialguinea: '赤道几内亚',
    sao: '圣多美和普林西比',
    guinea: '几内亚',
    guineabissau: '几内亚比绍',
    sierraleone: '塞拉利昂',
    liberia: '利比里亚',
    ivorycoast: '科特迪瓦',
    burkinafaso: '布基纳法索',
    mali: '马里',
    niger: '尼日尔',
    senegal: '塞内加尔',
    gambia: '冈比亚',
    capeverde: '佛得角',
    mauritania: '毛里塔尼亚',

    // 大洋洲
    newzealand: '新西兰',
    fiji: '斐济',
    papuanewguinea: '巴布亚新几内亚',
    solomon: '所罗门群岛',
    vanuatu: '瓦努阿图',
    newcaledonia: '新喀里多尼亚',
    frenchpolynesia: '法属波利尼西亚',
    samoa: '萨摩亚',
    tonga: '汤加',
    kiribati: '基里巴斯',
    tuvalu: '图瓦卢',
    nauru: '瑙鲁',
    palau: '帕劳',
    marshall: '马绍尔群岛',
    micronesia: '密克罗尼西亚',
    cookislands: '库克群岛',
    niue: '纽埃',
    tokelau: '托克劳',
    pitcairn: '皮特凯恩群岛',

    // 加勒比海地区
    saintlucia: '圣卢西亚',
    saintvincent: '圣文森特和格林纳丁斯',
    americansamoa: '美属萨摩亚',
    saintkitts: '圣基茨和尼维斯',
    dominica: '多米尼克',
    britishvirginislands: '英属维尔京群岛',
    sintmaarten: '荷属圣马丁',
    turksandcaicos: '特克斯和凯科斯群岛',
    usvirginislands: '美属维尔京群岛',

    // 特殊地区和岛屿
    jersey: '泽西',
    guernsey: '根西',
    isleofman: '马恩岛',
    alandislands: '奥兰群岛',
    svalbard: '斯瓦尔巴群岛',
    mayotte: '马约特',
    northmacedonia: '北马其顿',
    southsudan: '南苏丹',
    saintpierre: '圣皮埃尔和密克隆',
    guadeloupe: '瓜德罗普',
    saintmartin: '圣马丁岛',
    saintbarthelemy: '圣巴泰勒米',
    sinteustatius: '圣尤斯特歇斯',
    saba: '萨巴',
    bonaire: '博奈尔',
    curacao: '库拉索',
    easttimor: '东帝汶',
    wallisandfutuna: '瓦利斯和富图纳',
    falklandislands: '福克兰群岛',
  },
}
